import { Pitch } from '@/common/assets';
import type { LineupProps } from './Lineup.types';
import { LineupLine } from './LineupLine';

// Offset of the first line from the top of the pitch.
const OFFSET = 20;
// Base width for the forward line. It will grow for each line below it.
const FORWARD_WIDTH = 300;
// Defines how much wider each line should be compared to the previous one.
const GROWTH_RATE = 32;

export default function Lineup(props: LineupProps) {
  const { lines, jerseySrc, enabledStats } = props;

  return (
    <div className="relative w-fit" style={{ paddingTop: OFFSET }}>
      <Pitch />
      <div className="absolute inset-0 flex flex-col items-center justify-between">
        {lines.map((line, index) => (
          <LineupLine
            key={line.map((player) => player.name).join('-')}
            players={line}
            jerseySrc={jerseySrc}
            enabledStats={enabledStats}
            width={FORWARD_WIDTH + GROWTH_RATE * index}
          />
        ))}
      </div>
    </div>
  );
}
